import styled from '@emotion/styled'
import * as v from 'variables/styled'

export const PurchaseGroupMenuContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '10px',
  flexWrap: 'wrap',

  '.cardMenu': {
    width: '200px', 
    height: '200px',
    margin: '0px 10px 10px 0px',
  }
})

export const BottomActionsContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%', 
  margin: '10px 0px',
})